import RangeSlider from 'components/Basic/RangeSlider/RangeSlider';
import {
    filterGroupTitleTwClass,
    filterGroupTwClass,
    getFilterGroupArrowTwClass,
    getFilterGroupContentTwClass,
} from 'components/Blocks/Product/Filter/FilterGroup/FilterGroup';
import { getPriceRounded } from 'helpers/mappers/price';
import { useCurrentFilterQuery } from 'helpers/queryParams/useCurrentFilterQuery';
import { useUpdateFilterQuery } from 'helpers/queryParams/useUpdateFilterQuery';
import { ArrowIcon } from 'public/svg/IconsSvg';
import { useCallback, useState } from 'react';

type FilterGroupPriceProps = {
    title: string;
    initialMinPrice: string;
    initialMaxPrice: string;
};

const TEST_IDENTIFIER = 'blocks-product-filter-filtergroup-price';

export const FilterGroupPrice: FC<FilterGroupPriceProps> = ({ title, initialMinPrice, initialMaxPrice }) => {
    const [isGroupOpen, setIsGroupOpen] = useState(true);
    const { updateFilterPriceMinimumQuery, updateFilterPriceMaximumQuery } = useUpdateFilterQuery();
    const filterQuery = useCurrentFilterQuery();

    const { minimalPrice, maximalPrice } = filterQuery || {};
    const minPriceOption = getPriceRounded(initialMinPrice);
    const maxPriceOption = getPriceRounded(initialMaxPrice);

    const onSetMinimalPrice = useCallback(
        (value: number) => {
            if (minPriceOption !== value) {
                updateFilterPriceMinimumQuery(minPriceOption === value ? undefined : value);
            }
        },
        [minPriceOption, updateFilterPriceMinimumQuery],
    );

    const onSetMaximalPrice = useCallback(
        (value: number) => {
            if (maxPriceOption !== value) {
                updateFilterPriceMaximumQuery(maxPriceOption === value ? undefined : value);
            }
        },
        [updateFilterPriceMaximumQuery, maxPriceOption],
    );

    return (
        <div className={filterGroupTwClass} data-testid={TEST_IDENTIFIER}>
            <div className={filterGroupTitleTwClass} onClick={() => setIsGroupOpen((prev) => !prev)}>
                {title}
                <ArrowIcon className={getFilterGroupArrowTwClass(isGroupOpen)} />
            </div>
            <div className={getFilterGroupContentTwClass(isGroupOpen)}>
                <RangeSlider
                    min={minPriceOption}
                    max={maxPriceOption}
                    minValue={minimalPrice || minPriceOption}
                    maxValue={maximalPrice || maxPriceOption}
                    setMinValueCallback={onSetMinimalPrice}
                    setMaxValueCallback={onSetMaximalPrice}
                />
            </div>
        </div>
    );
};
